import { array } from 'fp-ts';
import { AccountNoteResult, useRepositorySuspenseQuery } from '@mews-commander/data-access';
import { keyById } from '@mews/fp';
import { Identifiable } from '@mews/std';

interface useGuestNotesQueryProps {
    accountIds: string[];
}

const convertIntoRecord = <E extends Identifiable>(entity: Array<E> | null | undefined) =>
    entity && array.isNonEmpty(entity) ? keyById(entity) : undefined;

const select = (data: AccountNoteResult) => ({
    accountNotes: data.accountNotes,
    profiles: convertIntoRecord(data.profiles),
});

export const useGuestNotesQuery = ({ accountIds }: useGuestNotesQueryProps) =>
    useRepositorySuspenseQuery('accountNotes', 'getAll', { accountIds, extent: { profiles: true } }, { select });
